export default [
  {
    path: '/activity-anniversary2025/index',
    name: 'index',
    component: () => import('@/views/activity-anniversary2025/index'),
    meta: {
      title: '15周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
  {
    path: '/activity-anniversary2025/components/giftaddress',
    name: 'giftaddress',
    component: () => import('@/views/activity-anniversary2025/components/giftaddress'),
    meta: {
      title: '15周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
  {
    path: '/activity-anniversary2025/components/giftList',
    name: 'giftList',
    component: () => import('@/views/activity-anniversary2025/components/giftList'),
    meta: {
      title: '15周年庆典，狂欢生日趴，赢多重惊喜礼-高考直通车'
    }
  },
]
